import { Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import leasdrboardMemberListImg from "assets/leaderboards-member.png";
import { FormSection } from "components/FormControls/FormSection";
import { HelpPanel } from "components/HelpPanel/HelpPanel";
import { SectionWrapper } from "components/Layout/Campaign/Direct/CampaignForm/Summary/SectionWrapper";
import { BasicInfo } from "components/Layout/Campaign/Direct/CampaignForm/Summary/Sections/BasicInfo";
import { useMessage } from "hooks/intl";
import { DefaultLanguageDataState } from "reduxState/translations/translationsSlice";
import { LeaderboardStepsIds, LeaderboardStepsUnion } from "../LeaderboardForm";
import { useStyles } from "../styles";

interface Props {
  values: any;
  defaultLang: DefaultLanguageDataState;
  skipToStep: (id: LeaderboardStepsUnion) => void;
  errors: any;
}

export const Summary = ({ values, defaultLang, skipToStep, errors }: Props) => {
  const { message } = useMessage();
  const classes = useStyles();
  const { translations, active, activity, visibility, displayOrder } = values;

  return (
    <Grid container spacing={12}>
      <Grid size={{ xs: 8 }}>
        <FormSection>
          <SectionWrapper
            title={message({ id: "leaderboardBasicInfoSummary" })}
            onClick={() => skipToStep(LeaderboardStepsIds.INFO)}
          >
            <BasicInfo
              defaultLang={defaultLang}
              translations={translations}
              active={active}
              activity={activity}
              visibility={visibility}
              displayOrder={displayOrder}
              type="leaderboard"
              errors={errors}
            />
          </SectionWrapper>
        </FormSection>
      </Grid>
      <Grid size={{ xs: 4 }}>
        <HelpPanel
          title="leaderboards"
          description={
            <div>
              <Typography>
                {message({ id: "summaryLeaderboardsHelpDesc" })}
                <img
                  className={classes.img}
                  src={leasdrboardMemberListImg}
                  alt="leaderboard"
                />
              </Typography>
            </div>
          }
        />
      </Grid>
    </Grid>
  );
};
